'use client';

import { useEffect } from 'react';
import { usePriceAndFitmentContext } from 'app/[lang]/[esite]/contexts/price-and-fitment-context/price-and-fitment-context';
import { sendGTMEvent } from '@next/third-parties/google';
import { useViewItem } from 'hooks/analytics/use-view-item-event';
import { AnalyticsListenerForPDPProps } from './types';
import { transformProductPriceData } from 'app/[lang]/[esite]/(core)/(search-display)/utils/utils';
import {
  getSessionStorage,
  removeSessionStorage
} from '@cat-ecom/common/utils/storageUtils';
import { FUSION_QUERY_ID } from '../../constants/constants';

const AnalyticsListenerForPDP = ({
  cartId,
  locationId,
  products,
  serialNumber,
  priceAndAvailabilityKey,
  fusionQueryId,
  pageName,
  priceData
}: AnalyticsListenerForPDPProps) => {
  const { priceAndAvailability, fitmentResponse } =
    usePriceAndFitmentContext() ?? {};
  const { fireEvent: fireUseViewItem } = useViewItem();
  const productsWithPriceData = transformProductPriceData(
    products,
    priceAndAvailability,
    serialNumber,
    fitmentResponse,
    pageName
  );

  useEffect(() => {
    const pushFusionQueryId = getSessionStorage(FUSION_QUERY_ID);
    if (pushFusionQueryId) {
      sendGTMEvent({ lucid_fusion_query_id: pushFusionQueryId });
    }
    removeSessionStorage(FUSION_QUERY_ID);
  }, []);

  useEffect(() => {
    const searchItemListData = {
      item_list_id: pageName,
      item_list_name: pageName
    };
    if (productsWithPriceData?.length > 0) {
      fireUseViewItem({
        cartId,
        products: productsWithPriceData,
        locationId,
        itemListData: searchItemListData,
        isProductsData: true,
        priceData
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    fireUseViewItem,
    productsWithPriceData,
    cartId,
    locationId,
    priceAndAvailabilityKey
  ]);

  return null;
};
export default AnalyticsListenerForPDP;
